const DownloadCsv = (csvString, name) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = `data:application/octet-stream;base64,${csvString}`;
  downloadLink.download = `${name}.csv`;
  downloadLink.click();
};

export default DownloadCsv;
